<template>
  <div class="page_label" v-loading="loading" element-loading-text="加载中···">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="人员标签" name="1">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>全局标签</span>
            <span class="handelspan">
              <span class="handelBtn cp" @click="addLabel('','group',1,0)">新增标签组+</span>
              <span v-if="checkList.length>0">
                <!-- <span class="handelBtn cp" @click="handelLabel('0',0)">禁用</span>
                <span class="handelBtn cp" @click="handelLabel('1',0)">启用</span> -->
                <!-- <span class="handelBtn cp" @click="editlLabel(0)">修改标签名</span> -->
              </span>
            </span>
          </div>
          <div class="labItem">
            <div class="labGroup" v-for="(item,index) in publicList" :key="item.LbGroup.Id" @mouseenter="mouseenter(item)" @mouseleave="mouseleave(item)">
              <div class="groupname">
                {{item.LbGroup.LableName}}
              </div>
              <div>
                <div class="flex">
                  <el-checkbox-group v-model="checkList">
                    <el-checkbox border v-for="(lab,index) in item.LbGroupVallist" :label="lab" :key="index" @change="checked=>handleCheckedAllLabelsChange(checked,lab)">
                      <span v-if="!lab.IsEnable">
                        <i class="el-icon-warning-outline" style="color:#f56c6c;font-size: 16px;" title="该标签已被禁用"></i>
                      </span>
                      <span :class="!lab.IsEnable ? 'banlabel' : ''" :title="!lab.IsEnable ? '该标签已被禁用' : ''">{{lab.LableName}}</span>
                    </el-checkbox>
                    <span class="handelBtn cp" @click="addLabel(item,'',1,0)">新增标签+</span>
                    <!-- <span class="handelBtn cp" @click="addLabel(item,'edit',1,0)">修改标签组名称</span> -->
                    <span class="handelBtn cp" @click="handelLabel('2',0)">删除</span>
                    <span class="handelBtn cp" v-if="item.LbGroupVallist.length == 0" @click="delLabelGroup(item,1,0)">删除标签组</span>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
          </div>
        </el-card>

        <!-- 私人 -->
        <!-- <el-card class="box-card" style="margin-top: 30px;">
          <div slot="header" class="clearfix">
            <span>私人标签</span>
            <span class="handelspan">
              <span class="handelBtn cp" @click="addLabel('','group',1,1)">新增标签组+</span>
              <span v-if="checkList2.length>0">
                <span class="handelBtn cp" @click="handelLabel('0',1)">禁用</span>
                <span class="handelBtn cp" @click="handelLabel('1',1)">启用</span>

                <span class="handelBtn cp" @click="editlLabel(1)">修改标签名称</span>
              </span>
            </span>
          </div>
          <div class="labItem">
            <div class="labGroup" v-for="(item,index) in privateList" :key="item.LbGroup.Id" @mouseenter="mouseenter(item)" @mouseleave="mouseleave(item)">
              <div class="groupname">
                {{item.LbGroup.LableName}}
              </div>
              <div>
                <div class="flex">
                  <el-checkbox-group v-model="checkList2">
                    <el-checkbox v-for="(lab,index) in item.LbGroupVallist" :label="lab" :key="index" @change="checked=>handleCheckedAllLabelsChange(checked,lab)">
                      <span v-if="!lab.IsEnable">
                        <i class="el-icon-warning-outline" style="color:#f56c6c;font-size: 16px;" title="该标签已被禁用"></i>
                      </span>
                      <span :class="!lab.IsEnable ? 'banlabel' : ''" :title="!lab.IsEnable ? '该标签已被禁用' : ''">{{lab.LableName}}</span>
                    </el-checkbox>
                    <span class="handelBtn cp" @click="addLabel(item,'',1,1)">新增标签+</span>
                  <span class="handelBtn cp" @click="addLabel(item,'edit',1,1)">修改标签组名称</span>
                  <span class="handelBtn cp" @click="handelLabel('2',1)">删除</span>
                  <span class="handelBtn cp" v-if="item.LbGroupVallist.length == 0" @click="delLabelGroup(item,1,1)">删除标签组</span>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
          </div>
        </el-card> -->
      </el-tab-pane>
      <el-tab-pane label="岗位标签" name="2">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>全局标签</span>
            <span class="handelspan">
              <span class="handelBtn cp" @click="addLabel('','group',1,0)">新增标签组+</span>
              <span v-if="checkList.length>0">
                <!-- <span class="handelBtn cp" @click="handelLabel('0',0)">禁用</span>
                <span class="handelBtn cp" @click="handelLabel('1',0)">启用</span> -->

              </span>
            </span>
          </div>
          <div class="labItem">
            <div class="labGroup" v-for="(item,index) in PublicJobList" :key="item.LbGroup.Id" @mouseenter="mouseenter(item)" @mouseleave="mouseleave(item)">
              <div class="groupname">
                <!-- <div v-if="index==0" class="lbName">标签组</div> -->
                {{item.LbGroup.LableName}}
              </div>
              <div>
                <div v-if="index==0" class="lbName">标签</div>
                <div class="flex">
                  <el-checkbox-group v-model="checkList">
                    <el-checkbox v-for="(lab,index) in item.LbGroupVallist" :label="lab" :key="index" @change="checked=>handleCheckedAllLabelsChange(checked,lab)">
                      <span v-if="!lab.IsEnable">
                        <i class="el-icon-warning-outline" style="color:#f56c6c;font-size: 16px;" title="该标签已被禁用"></i>
                      </span>
                      <span :class="!lab.IsEnable ? 'banlabel' : ''" :title="!lab.IsEnable ? '该标签已被禁用' : ''">{{lab.LableName}}</span>
                    </el-checkbox>
                    <span class="handelBtn cp" @click="addLabel(item,'',1,0)">新增标签+</span>
                  <!-- <span class="handelBtn cp" @click="addLabel(item,'edit',1,0)">修改标签组名称</span> -->
                  <span class="handelBtn cp" @click="handelLabel('2',0)">删除</span>
                  <span class="handelBtn cp" v-if="item.LbGroupVallist.length == 0" @click="delLabelGroup(item,1,0)">删除标签组</span>
                  </el-checkbox-group>
                </div>
              </div>

            </div>
          </div>
        </el-card>
      </el-tab-pane>
    </el-tabs>

    <el-dialog :title="addtype=='group' ? '标签组名称：' : addtype=='edit' ? '修改标签组名称' : '标签名称：'" :visible.sync="visibleAdd" width="450px">
      <div>
        <el-form>
          <el-form-item :label="addtype=='' ? '标签名称：' : '标签组名称：'" :label-width="'100px'">
            <el-input v-model="infoQuery.lableName"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="visibleAdd = false">取消</button>
        <button class="search" @click="confirmAdd()" style="margin-left:10px;font-weight:600">确定</button>
      </span>
    </el-dialog>

    <el-dialog title="修改标签名称" :visible.sync="visibleEdit" width="450px">
      <div>
        <el-form>
          <el-form-item label="标签名称：" :label-width="'100px'">
            <el-input v-model="infoQuery.lableName"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="visibleEdit = false">取消</button>
        <button class="search" @click="confirmAdd()" style="margin-left:10px;font-weight:600">确定</button>
      </span>
    </el-dialog>

    <el-dialog title="删除标签" :visible.sync="visibleDel" width="384px">
      <div>请确认是否删除选中的{{isPrivately ? checkList2.length + '个' : checkList.length + '个'}}标签</div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="visibleDel = false">取消</button>
        <button class="search" @click="beforeSubmit()" style="margin-left:10px;font-weight:600">确定</button>
      </span>
    </el-dialog>

    <el-dialog title="删除标签组" :visible.sync="visibleDelGroup" width="384px">
      <div>请确认删除标签组 {{ infoQuery.lableName }}</div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="visibleDelGroup = false">取消</button>
        <button class="search" @click="confirmDelGroup()" style="margin-left:10px;font-weight:600">确定</button>
      </span>
    </el-dialog>

    <el-dialog :title="isban=='0' ? '禁用标签' : '启用标签'" :visible.sync="visibleBan" width="384px">
      <div>请确认是否{{isban=='0' ? '禁用' : '启用'}}选中的{{isPrivately ? checkList2.length + '个' : checkList.length + '个'}}标签</div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="visibleBan = false">取消</button>
        <button class="search" @click="beforeSubmit()" style="margin-left:10px;font-weight:600">确定</button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import xz from "./../../../common.vue";
export default {
  data() {
    return {
      activeName: '1',
      publicList: [],
      privateList: [],
      PublicJobList: [],
      isban: '0',
      checkList: [],
      checkList2: [],
      check: [],
      isPrivately: 0,//是否私有
      addtype: '',
      role: localStorage.loginRoletype,
      visibleDel: false,//删除弹窗
      visibleBan: false,//禁用/启用弹窗
      visibleAdd: false,//新增标签组/标签
      visibleEdit: false,//
      loading: false,
      visibleDelGroup: false,//删除标签组
      infoQuery: {
        Id: 0,
        lableName: '',
        lableType: Number(this.activeName),
        IsPrivately: 1,
        IsEnable: 1,
        parentId: 0,
        IsDeleted: 0
      }
    };
  },
  created() {
    this.GetLabelManagement();
  },
  methods: {
    handleCheckedAllLabelsChange(checked, value) {
      console.log(checked, value, this.checkList)
    },
    handleClick() {
      this.checkList = [];
      this.checkList2 = [];
    },
    //鼠标悬浮
    mouseenter(item) {
      this.$set(item, 'show', true)
    },
    mouseleave(item) {
      this.$set(item, 'show', false)
    },
    //获取标签列表
    GetLabelManagement() {
      this.loading = true;
      this.publicList = [],
        this.privateList = [],
        xz.GetLabelManagement(this.role).then(res => {
          this.loading = false;
          if (res.status == 'ok') {
            this.publicList = res.data.PublicPersonList;
            this.privateList = res.data.PrivatelyList;
            this.PublicJobList = res.data.PublicJobList;
          }
        })
    },
    //新增标签
    addLabel(item, addtype, lableType, IsPrivately) {
      this.clearQuery();
      this.addtype = addtype;
      this.infoQuery.IsPrivately = IsPrivately;
      !addtype ? this.infoQuery.parentId = item.LbGroup.Id : '';
      addtype == 'edit' ? this.infoQuery.Id = item.LbGroup.Id : '';
      addtype == 'edit' ? this.infoQuery.lableName = item.LbGroup.LableName : '';
      this.visibleAdd = true;
      console.log(item)
    },
    delLabelGroup(item, lableType, IsPrivately) {
      this.clearQuery();
      this.infoQuery.IsPrivately = IsPrivately;
      this.infoQuery.Id = item.LbGroup.Id;
      this.infoQuery.lableName = item.LbGroup.LableName;
      // this.infoQuery.IsDeleted = 1;
      this.visibleDelGroup = true;
      console.log(this.infoQuery)
    },
    confirmDelGroup() {
      this.infoQuery.IsDeleted = 1;
      xz.setLabelManagement(this.infoQuery, this.role).then(res => {
        if (res.status == 'ok') {
          this.$message.success('删除成功！');
          this.GetLabelManagement();
        } else {
          this.$message.error(res.msg);
        }
        this.visibleDelGroup = false
      })
    },
    //重置参数
    clearQuery() {
      this.infoQuery = {
        Id: 0,
        lableName: '',
        lableType: Number(this.activeName),
        IsPrivately: 1,
        IsEnable: 1,
        parentId: 0,
        IsDeleted: 0
      }
    },
    //确认新增
    confirmAdd() {
      if (this.infoQuery.lableName) {
        xz.setLabelManagement(this.infoQuery, this.role).then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功！');
            this.GetLabelManagement();
            this.checkList = [];
            this.checkList2 = [];
          } else {
            this.$message.error(res.msg);
          }
        })
        this.visibleAdd = false;
        this.visibleEdit = false;
      } else {
        this.$message.warning('请输入名称')
      }
    },
    //禁用/启用/删除弹窗
    handelLabel(val, isPrivately) {
      this.isPrivately = isPrivately;
      this.isban = val;
      val == '2' ? this.visibleDel = true : this.visibleBan = true;
    },
    //修改标签名称
    editlLabel(isPrivately) {
      if ((isPrivately && this.checkList2.length > 1) || (!isPrivately && this.checkList.length > 1)) {
        this.$message.warning('只能选择一个标签修改名称')
      } else {
        let data = isPrivately ? this.checkList2[0] : this.checkList[0];
        this.infoQuery = {
          Id: data.Id,
          lableName: data.LableName,
          lableType: Number(data.LableType),
          IsPrivately: data.IsPrivately,
          IsEnable: data.IsEnable,
          parentId: data.ParentId,
          IsDeleted: data.IsDeleted,
        }
        this.visibleEdit = true;
      }
    },
    beforeSubmit() {
      let list = this.isPrivately ? this.checkList2 : this.checkList;
      switch (this.isban) {
        case '0':
          list.forEach((ele, index) => {
            ele.IsEnable = 0;
            if (index + 1 == list.length) {
              this.check = list;
              this.confirmHandel();
            }
          });
          break;
        case '1':
          list.forEach((ele, index) => {
            ele.IsEnable = 1;
            if (index + 1 == list.length) {
              this.check = list;
              this.confirmHandel();
            }
          });
          break;
        case '2':
          list.forEach((ele, index) => {
            ele.IsDeleted = 1;
            if (index + 1 == list.length) {
              this.check = list;
              this.confirmHandel();
            }
          });
          break;
      }
    },
    //确认禁用/启用/删除
    confirmHandel() {
      xz.setlabelmanagementbatch(this.check, this.role).then(res => {
        if (res.status == 'ok') {
          this.$message.success('操作成功！');
          this.GetLabelManagement();
          this.visibleDel = false;
          this.visibleBan = false;
          this.checkList = [];
          this.checkList2 = [];
        } else {
          this.$message.error(res.msg);
          this.visibleDel = false;
          this.visibleBan = false;
          this.checkList = [];
          this.checkList2 = [];
        }
      })
    }
  }
}
</script>

<style scoped>
.page_label {
  padding: 0 15px 30px 15px;
}
.clearfix {
  font-size: 16px;
}
.handelspan {
  margin-left: 100px;
}
.handelBtn {
  font-size: 12px;
  color: #79c750;
  margin-right: 20px;
  padding-top: 2px;
  white-space: nowrap;
}
.box-card {
  width: auto;
}
.labGroup {
  margin-bottom: 20px;
}
.groupname {
  font-size: 14px;
  margin-right: 10px;
  white-space: nowrap;
  font-weight: 600;
  margin-bottom: 10px;
}
.banlabel {
  color: #c0c4cc;
}
.lbName {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
}
</style>

<style >
.labGroup .el-checkbox__label {
  padding-left: 5px;
}
.labGroup .el-checkbox {
  margin-right: 20px;
}
.labItem .el-checkbox {
  border: 1px solid #ddd;
  padding: 2px 3px;
  border-radius: 3px;
  height: auto;
  margin: 5px 20px 0 0;
}
.labItem .el-button + .el-button,
.el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0;
}
.labItem .el-checkbox.is-bordered.is-checked{
  border-color:#ddd
}
</style>